import {
  IonButton,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCol,
  IonContent,
  IonGrid,
  IonIcon,
  IonItem, IonItemDivider,
  IonList, IonLoading, IonModal,
  IonPage,
  IonRow,
  IonText, IonToast,
  isPlatform,
} from "@ionic/react";
import React, {useState} from "react";
import { Autoplay, Navigation, Pagination } from "swiper";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import Header from "../../components/Header";
import { AuthContext } from "../../providers/authContext";
import "./AnaSayfa.css";
import { waterSharp } from "ionicons/icons";
import {NfcCardInfo} from "../entities/NfcCardInfo";
import {useBaylanCard} from "../../hooks/useBaylanCard";
import {useHistory} from "react-router-dom";

const AnaSayfa: React.FC = () => {
  const { kurumBilgileri, setTitle } = React.useContext(AuthContext);
  const { hasNfc, readCard } = useBaylanCard();
  const history = useHistory();
  const [toastMessage, setToastMessage] = useState<string>();
  const [showLoading, setShowLoading] = useState<boolean>(false);
  const [nfcAvailable, setNfcAvailable] = React.useState(false);
  const [isNfcModalOpen, setIsNfcModalOpen] = React.useState(false);

  React.useEffect(() => {
    kurumBilgileri && setTitle(kurumBilgileri.kisaTanim);
  }, [kurumBilgileri, setTitle]);

  React.useEffect(() => {
    const isAndroidPlatform = isPlatform("android");
    console.log('isAndroidPlatform: ', isAndroidPlatform);
    if (!isAndroidPlatform) return;

    let cancelled = false;

    (async () => {
      try {
        console.log('Checking for NFC support...');
        // Requires an NFC plugin (example shown for @capawesome/capacitor-nfc)
        const availability = await hasNfc();
        console.log('Nfc availability: ', availability);
        if (!cancelled) setNfcAvailable(availability);
      } catch {
        // Plugin missing / running on web / not supported
        if (!cancelled) setNfcAvailable(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [hasNfc]);

  return (
    <IonPage>
      <Header />
      <IonLoading
        isOpen={showLoading}
        onDidDismiss={() => setShowLoading(false)}
        message={"Lütfen Bekleyin..."}
      />
      <IonContent fullscreen>
        <IonToast
          isOpen={toastMessage !== undefined}
          onDidDismiss={() => setToastMessage(undefined)}
          message={toastMessage}
          duration={2000}
          position="top"
        />
        <IonList>
          {!kurumBilgileri?.kurumKodu.startsWith("35") &&
            !kurumBilgileri?.kurumKodu.startsWith("48") && (
              <IonItem>
                <Swiper
                  pagination={{
                    clickable: true,
                  }}
                  autoplay={{ delay: 3000, disableOnInteraction: false }}
                  navigation
                  loop
                  speed={400}
                  modules={[Autoplay, Pagination, Navigation]}
                >
                  <SwiperSlide className="fill">
                    <div className="image-container">
                      <img src="assets/001.jpg" />
                      <div className="text-block">
                        <h5>{kurumBilgileri?.kisaTanim}</h5>
                        <p>e-Belediye İşlemlerine Hoşgeldiniz.</p>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide className="fill">
                    <div className="image-container">
                      <img src="assets/002.jpg" />
                      <div className="text-block">
                        <p>BELEDİYE'YE AİT TÜM ÖDEMELERİNİZ</p>
                        <p>Emlak Vergileri (Bina, Arsa, Arazi),</p>
                        <p>Çevre Temizlik Vergisi,</p>
                        <p>İlan Reklam Vergisi,</p>
                        <p>Eğlence Vergisi,</p>
                        <p>Kira Ödemesi,</p>
                        <p>
                          Ve Diğer Tüm Ödemelerinizi Buradan Yapabilirsiniz !
                        </p>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide className="fill">
                    <div className="image-container">
                      <img src="assets/003.jpg" />
                      <div className="text-block">
                        <p>SİSTEMİMİZE ÜYE OLUN</p>
                        <p>Böylece Beyan ve Bildirim Sorgulama,</p>
                        <p>Geçmiş Tahsilatları İzleme v.b.</p>
                        <p>İşlemlere 7 /24 Internet Üzerinden</p>
                        <p>Ücretsiz Olarak Ulaşabilirsiniz !</p>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide className="fill">
                    <div className="image-container">
                      <img src="assets/004.jpg" alt="004.jpg" />
                      <div className="text-block">
                        <p>
                          <b>E-BELEDİYE İŞLEMLERİ GÜVENLİDİR</b>
                        </p>
                        <p>E-Belediye Sayfasından Yapacağınız</p>
                        <p>Tüm İşlemler Dünyaca Kabul Görmüş</p>
                        <p>128 Bit SSL Şifrelemesi Kullanan Güvenlik</p>
                        <p>Sertifikaları İle Yapılmaktadır.</p>
                      </div>
                    </div>
                  </SwiperSlide>
                </Swiper>
              </IonItem>
            )}
          <IonItemDivider />

          {isPlatform("android") && nfcAvailable && (
            <IonItem lines="none" style={{'--inner-padding-end': '0', '--padding-start': '0'}}>
              <IonCard button className="nfc-card" onClick={async () => {
                setIsNfcModalOpen(true);
                try {
                  console.log('NFC Card Reading...');
                  const result = await readCard(); // kart değene kadar burada bekler
                  console.log('NFC Card Read Result: ', result);
                  if (result.kod === '00') {
                    if (Number(result.aboneNo) === 0) {
                      setIsNfcModalOpen(false);
                      alert("Karta tanımlı bir abone bilgisi bulunamadı. Lütfen başka bir kart ile deneyin.");
                      return;
                    }
                    setShowLoading(true);
                    setIsNfcModalOpen(false);

                    history.push("/page/NfcCardOperations", {
                      nfcCardInfo: result,
                    });
                  } else {
                    setToastMessage(`Okuma başarısız: ${result.aciklama}`);
                  }
                } catch (err: any) {
                  console.error("NFC Error: ", err);
                  setToastMessage(err.message);
                }
              }}>
                <div className="nfc-card-content">
                  <img src="assets/musluk.png" alt="musluk.png" className="nfc-icon"/>
                  <span className="nfc-text">Su Yükleme</span>
                </div>
              </IonCard>
            </IonItem>
          )}
          <IonItemDivider />
          <IonItem>
            <IonCard>
              <IonCardHeader>
                <IonText>
                  Borç Sorgulama
                  {kurumBilgileri?.eBelediyeClientId && " / Ödeme"} İşlemleri
                </IonText>
              </IonCardHeader>
              <IonCardContent>
                <IonGrid>
                  {kurumBilgileri?.menus
                    .filter((m) => m.title.toLowerCase().startsWith("borç"))
                    .map((m, i) => (
                      <IonRow key={i}>
                        {m.menuItems.map((mi, j) => (
                          <IonCol key={j}>
                            <IonCard button routerLink={mi.url} color="primary">
                              <IonButton
                                size="default"
                                expand="full"
                                fill="solid"
                              >
                                {mi.title}
                              </IonButton>
                            </IonCard>
                          </IonCol>
                        ))}
                      </IonRow>
                    ))}
                </IonGrid>
              </IonCardContent>
            </IonCard>
          </IonItem>
          <IonItem>
            <IonModal
              isOpen={isNfcModalOpen}
              onDidDismiss={() => setIsNfcModalOpen(false)}
              initialBreakpoint={0.5}
              breakpoints={[0, 0.5, 0.75]}
            >
              <IonContent className="ion-padding">
                <IonText>
                  <h2>Kartı Okutunuz</h2>
                  <p>Lütfen telefonunuzu Baylan NFC kartının yakınında sabit tutun.</p>
                </IonText>

                <div style={{ display: "flex", justifyContent: "center", margin: "16px 0" }}>
                  <img
                    src="assets/NFC.gif"
                    alt="NFC"
                    style={{ width: 225, maxWidth: "80%", height: "auto" }}
                  />
                </div>

                <IonButton expand="block" onClick={() => setIsNfcModalOpen(false)}>
                  Vazgeç
                </IonButton>
              </IonContent>
            </IonModal>
            <IonText>
              <h5>
                Yazdırma işlemleri için bilgisayarınızda PDF görüntüleyici
                olması gerekmektedir.
              </h5>
            </IonText>
          </IonItem>
        </IonList>
      </IonContent>
    </IonPage>
  );
};

export default React.memo(AnaSayfa);
